import jwtDecoder from 'jwt-decode'

const AUTH_TOKEN = 'auth'

/**
|--------------------------------------------------
| Authentication Token
|--------------------------------------------------
*/
export const setAuthenticationToken = token =>
  localStorage.setItem(AUTH_TOKEN, token)

export const getAuthenticationToken = () => localStorage.getItem(AUTH_TOKEN)

export const removeAuthenticationToken = () =>
  localStorage.removeItem(AUTH_TOKEN)

export const getUserData = () => {
  const authToken = getAuthenticationToken()

  let user

  try {
    user = jwtDecoder(authToken)
  } catch (error) {
    user = null
  }

  return user
}



// WEBPACK FOOTER //
// ./src/utils/token.js